import React, { Component } from 'react'
import { links, mixpanel, constants } from 'common/helpers'
import cx from 'classnames'

import Link from 'components/ui/Link/Link'

import s from './InviteButton.scss'

import freeIcon from './images/free.svg'


class InviteButton extends Component {

  onClick = () => {
    mixpanel.track(constants.analyticsEvents.shareLinkClick, { placement: 'mobile top navigation bar' })
  }

  render() {
    const { className } = this.props

    return (
      <Link
        className={cx(s.inviteButton, className)}
        to={links.invite}
        onClick={this.onClick}
      >
        <img src={freeIcon} alt="Invite" />
      </Link>
    )
  }
}


export default InviteButton
